// Effect Managers
import { put, select, call } from 'redux-saga/effects'

// Exports
export default function composeHandleCreate ({
  actionCreators,
  url,
  token$,
  handleFetch,
}) {
  return function *handleCreate ({
    url: maybeUrl,
    queryParams,
    id,
    data: maybeData,
    model: body = maybeData,
  }, {
    encode = true,
    reduce = true,
  }) {
    if (maybeData) {
      console.warn(
        'Dispatching a create or update action using "data" is deprecating.' +
        ' Please use "model" instead.'
      )
    }

    const token = yield select(token$)

    const options = yield {
      url: maybeUrl || url,
      token,
      queryParams,
      id,
      method: 'POST',
      body,
      encode,
    }

    yield put(actionCreators.creating({
      queryParams,
      model: body,
    }))

    const { bad, status, data, model, response } = yield call(handleFetch, options)

    if (bad) {
      yield put(actionCreators.failCreate({
        queryParams,
        response,
        status,
      }))
    } else {
      yield put(actionCreators.created({
        queryParams,
        model,
        status,
      }))

      if (reduce) {
        yield put(actionCreators.receive({
          queryParams,
          data,
        }))
      }
    }

    return { status, response, data, model, error: bad }
  }
}
